export default __webpack_public_path__ + "static/media/szafy7.d52bb5bd.jpg";